import axios from "axios";

class DataFTEService {
  async getData() {
    return await axios.get(`data-fte/1`);
  }

  async updateDean(name: string) {
    return await axios.put(`data-fte/dean`, { name });
  }

  async updateDeputyDean(name: string) {
    return await axios.put(`data-fte/deputyDean`, { name });
  }
}

export default new DataFTEService();
